import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const AgencyPortfolioSiteHealthSchema = z.enum([
    "HEALTHY",
    "ATTENTION",
    "UNKNOWN",
    "NOT_LAUNCHED",
]);
export const AgencyPortfolioSummaryItemV1Schema = z
    .object({
    projectId: ProjectIdSchema,
    businessName: z.string().min(1),
    launchStatus: z.enum(["LAUNCHED", "IN_PROGRESS", "NOT_STARTED"]),
    siteHealth: AgencyPortfolioSiteHealthSchema,
    openClientRequests: z.number().int().nonnegative(),
    modernizationOpportunities: z.number().int().nonnegative(),
})
    .strict();
export const AgencyPortfolioSummaryV1Schema = z
    .object({
    schemaVersion: z.literal("agency-portfolio-summary.v1.0"),
    agencyId: AgencyIdSchema,
    generatedAt: z.string().datetime(),
    launchedSiteCount: z.number().int().nonnegative(),
    attentionHealthCount: z.number().int().nonnegative(),
    openRequestCount: z.number().int().nonnegative(),
    modernizationOpportunityCount: z.number().int().nonnegative(),
    items: z.array(AgencyPortfolioSummaryItemV1Schema),
})
    .strict();
//# sourceMappingURL=agency-portfolio-summary.js.map